import { IconArrowRight } from '@shared/ui/icons';
import { formatMillions } from '../financierFormat';
import {
  Section,
  SectionHeader,
  SectionTitle,
  SectionLink,
  StatGrid,
  MetricBox,
  MetricLabel,
  MetricValue,
  MetricNote,
} from './styled';

interface LiquiditySectionProps {
  accountsSummary: {
    total_current_balance: number;
    free_operational_cash: number;
    special_obs_balance: number;
    tax_reserve_balance: number;
    deposit_balance: number;
    total_overdraft_limit: number;
  };
}

export function LiquiditySection({ accountsSummary }: LiquiditySectionProps) {
  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Банковская ликвидность и остатки холдинга</SectionTitle>
        <SectionLink to="/agents/finance/accounts">
          Счета и выписки
          <IconArrowRight size={14} />
        </SectionLink>
      </SectionHeader>
      <StatGrid>
        <MetricBox>
          <MetricLabel>Консолидированный остаток</MetricLabel>
          <MetricValue>{formatMillions(accountsSummary.total_current_balance)}</MetricValue>
          <MetricNote>Все счета (р/с + ОБС + ЕНС + депозиты)</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Свободно для платежей</MetricLabel>
          <MetricValue $color="#10b981">{formatMillions(accountsSummary.free_operational_cash)}</MetricValue>
          <MetricNote>Без блокировок и спецсчетов</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Спецсчета ОБС (сопровождение)</MetricLabel>
          <MetricValue $color="#0ea5e9">{formatMillions(accountsSummary.special_obs_balance)}</MetricValue>
          <MetricNote>Целевые счета ГОЗ и субсидий</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Резервный налоговый счёт ЕНС</MetricLabel>
          <MetricValue $color="#8b5cf6">{formatMillions(accountsSummary.tax_reserve_balance)}</MetricValue>
          <MetricNote>Зарезервировано к 28 числу</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Депозиты / Овернайты</MetricLabel>
          <MetricValue>{formatMillions(accountsSummary.deposit_balance)}</MetricValue>
          <MetricNote>Процентный доход холдинга</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Одобренный овердрафт</MetricLabel>
          <MetricValue>{formatMillions(accountsSummary.total_overdraft_limit)}</MetricValue>
          <MetricNote>Доступно для покрытия кассовых разрывов</MetricNote>
        </MetricBox>
      </StatGrid>
    </Section>
  );
}
